/***
 * @file:
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Component, Input, OnInit } from '@angular/core';

import { SettingsService } from '@ithinkdt/shared/browser';
import { ThemeConfig } from '@ithinkdt/theme/models';

@Component({
  selector: 'dt-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  themeConfig: ThemeConfig;
  /** æ»çèåæ°æ® */
  menuData: object[];
  /** æ¯å¦ä¼ éè¿å»çä¸»èåæ°æ® */
  isAllMenuData = true;
  /** é¡¶é¨èåæ¾ç¤ºä¸ªæ° */
  topMenuItemsNumber = 100;
  @Input() topMenu = false;
  @Input() collapsed = false;

  constructor(private settings: SettingsService) {
    this.themeConfig = this.settings.userConfig['theme'] || {};

    if (this.themeConfig['topMenuItemsNumber']) {
      this.topMenuItemsNumber = this.themeConfig.topMenuItemsNumber;
    }
  }

  ngOnInit() {
    this.getStoredData();
  }

  getStoredData() {
    this.menuData = this.settings.menu;
  }
}
